<template>
  <div>
    <span class="live-user" @click="handleClick"
      ><div class="live-dot" />
      {{ getUserName(item) }}</span
    >
  </div>
</template>

<script>
export default {
  name: "live-user",
  model: {},
  props: {
    item: {
      type: Object,
      required: true
    },
    openUserPreviewModal: {
      type: Function,
      required: true
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    handleClick() {
      this.openUserPreviewModal(this.item);
    },
    getUserName(item) {
      if (!item) return '';
      
      let name = '';
      if (item.nickname && item.nickname !== "") {
        name = item.nickname;
      } else if (item.displayName && item.displayName !== "") {
        name = item.displayName;
      } else if (item.firstName && item.lastName) {
        name = `${item.firstName} ${item.lastName}`;
      }

      return name ? `${name} - ${item.email || ''}` : item.email || '';
    },
    changeRouteUser(item) {
      let vm = this;
      vm.$router.push({ name: "User Profile", params: item });
    },
  },
  watch: {},
};
</script>

<style scoped>
.live-dot {
  height: 10px;
  width: 10px;
  border-radius: 5px;
  background-color: green;
}
.live-user {
  display: flex;
  align-items: center;
  gap: 10px;
}
.live-user:hover {
  cursor: pointer;
}
</style>
